import {
  WorkItemServiceProvider,
  vsProviderName as WorkItemServiceProviderName,
} from "../";
import { ConfirmationWorkItemController } from "./controller";

confirmationConfig.$inject = [
  "formlyConfigProvider",
  WorkItemServiceProviderName,
];
export function confirmationConfig(
  formlyConfigProvider: AngularFormly.IFormlyConfig,
  workItemServiceProvider: WorkItemServiceProvider
) {
  workItemServiceProvider.addWorkItemType({
    name: "Confirmation",
    formlyFieldType: "processConfirmation",
  });

  formlyConfigProvider.setType({
    name: "processConfirmation",
    template: require("!html-loader!./index.html").default,
    controller: ConfirmationWorkItemController,
  });
}
